const prefixes = [
	{ long: '', short: '' },
	{ long: 'un', short: 'U' },
	{ long: 'duo', short: 'D' },
	{ long: 'tre', short: 'T' },
	{ long: 'quattuor', short: 'Q' },
	{ long: 'quin', short: 'Qi' },
	{ long: 'sex', short: 'Sx' },
	{ long: 'septen', short: 'Sp' },
	{ long: 'octo', short: 'O' },
	{ long: 'novem', short: 'N' }
]
const largeSteps = [
	{ long: 'decillion', short: 'Dc' },
	{ long: 'vigintillion', short: 'Vg' },
	{ long: 'trigintillion', short: 'Tg' },
	{ long: 'quadragintillion', short: 'Qg' },
	{ long: 'quinquagintillion', short: 'Qg' },
	{ long: 'sexagintillion', short: 'Sxg' },
	{ long: 'septuagintillion', short: 'Spg' },
	{ long: 'octogintillion', short: 'Og' },
	{ long: 'nonagintillion', short: 'Ng' },
	{ long: 'centillion', short: 'C' }
]
const formats: {
	long: string
	short: string
}[] = [
	{ long: 'thousand', short: 'K' },
	{ long: 'million', short: 'M' },
	{ long: 'billion', short: 'B' },
	{ long: 'trillion', short: 'T' },
	{ long: 'quadrillion', short: 'Qa' },
	{ long: 'quintillion', short: 'Qi' },
	{ long: 'sextillion', short: 'Sx' },
	{ long: 'septillion', short: 'Sp' },
	{ long: 'octillion', short: 'Oc' },
	{ long: 'nonillion', short: 'N' },
	...largeSteps.flatMap((largeStep) =>
		prefixes.map((prefix) => ({
			long: `${prefix.long}${largeStep.long}`,
			short: `${prefix.short}${largeStep.short}`
		}))
	)
]

enum Style {
	Short,
	Long
}

function formatBigInt(value: bigint, style: Style = Style.Short): string {
	if (typeof value !== 'bigint') throw new TypeError('Input is not a bigint')
	const negative = value < 0n
	const absValue = negative ? -value : value
	if (absValue < 1000n) {
		return value.toString()
	}

	const exponent = Math.floor(Number(absValue.toString().length - 1) / 3)
	const format = formats[exponent - 1]
	const divisor = 10n ** BigInt(exponent * 3)
	const formattedValue = ((absValue * 1000n) / divisor).toString()
	const integerPart = formattedValue.slice(0, -3)
	let decimalPart = formattedValue.slice(-3)

	if (style === Style.Short) {
		decimalPart = decimalPart.replace(/0+$/, '')
		const result = decimalPart
			? `${integerPart}.${decimalPart}${format.short}`
			: `${integerPart}${format.short}`
		return negative ? `-${result}` : result
	} else {
		if (exponent < 2) {
			return negative ? `-${absValue.toString()}` : absValue.toString()
		}
		if (absValue === 10n ** BigInt(3 * exponent)) {
			const result = `${integerPart} ${format.long}`
			return negative ? `-${result}` : result
		}
		while (decimalPart.length < 3) {
			decimalPart += '0'
		}
		const result = `${integerPart}.${decimalPart} ${format.long}`
		return negative ? `-${result}` : result
	}
}

export { formatBigInt, formats, Style }
